module.exports = __webpack_public_path__ + "assets/images/pending.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/pending.png
// module id = 1522
// module chunks = 1